import { jsx, jsxs } from "react/jsx-runtime";
import { Drumstick, Hand } from "@tamagui/lucide-icons";
import { Button, XStack, YStack } from "tamagui";
const outlined = {
  backgroundColor: "transparent",
  borderWidth: 2,
  borderColor: "$background",
  borderRadius: "$10",
  hoverStyle: {
    backgroundColor: "transparent",
    borderColor: "$backgroundPress"
  }
};
function BuildAButtonDemo() {
  return /* @__PURE__ */ jsx(YStack, { fullscreen: true, ov: "hidden", children: /* @__PURE__ */ jsxs(XStack, { mah: 200, y: -100, x: -40, rotate: "-10deg", children: [
    /* @__PURE__ */ jsx(ButtonCol, { y: 35, size: "$2", ...outlined, subTheme: "alt1", borderWidth: 1 }),
    /* @__PURE__ */ jsx(ButtonCol, { y: 30 }),
    /* @__PURE__ */ jsx(ButtonCol, { y: -50, ...outlined }),
    /* @__PURE__ */ jsx(ButtonCol, { ...outlined, icon: /* @__PURE__ */ jsx(Hand, {}) }),
    /* @__PURE__ */ jsx(ButtonCol, { size: "$6", subTheme: "alt2" }),
    /* @__PURE__ */ jsx(ButtonCol, { size: "$6", subTheme: "alt2", ...outlined }),
    /* @__PURE__ */ jsx(ButtonCol, { size: "$8", subTheme: "alt2", iconAfter: /* @__PURE__ */ jsx(Drumstick, {}), ...outlined }),
    /* @__PURE__ */ jsx(ButtonCol, { size: "$10", subTheme: "alt1" }),
    /* @__PURE__ */ jsx(ButtonCol, { size: "$8", subTheme: "alt2", ...outlined, borderRadius: 0 })
  ] }) });
}
function ButtonCol(props) {
  const subTheme = props.subTheme ? `_${props.subTheme}` : "";
  return /* @__PURE__ */ jsxs(YStack, { padding: "$2", space: "$3", children: [
    /* @__PURE__ */ jsx(Button, { theme: props.subTheme, ...props, children: "Hello" }),
    /* @__PURE__ */ jsx(Button, { theme: "orange" + subTheme, ...props, children: "Hello" }),
    /* @__PURE__ */ jsx(Button, { theme: "yellow" + subTheme, ...props, children: "Hello" }),
    /* @__PURE__ */ jsx(Button, { theme: "green" + subTheme, ...props, children: "Hello" }),
    /* @__PURE__ */ jsx(Button, { theme: "blue" + subTheme, ...props, children: "Hello" }),
    /* @__PURE__ */ jsx(Button, { theme: "purple" + subTheme, ...props, children: "Hello" }),
    /* @__PURE__ */ jsx(Button, { theme: "pink" + subTheme, ...props, children: "Hello" }),
    /* @__PURE__ */ jsx(Button, { theme: "red" + subTheme, ...props, children: "Hello" })
  ] });
}
export {
  BuildAButtonDemo
};
//# sourceMappingURL=BuildAButtonDemo.js.map
